import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import { Observable } from "rxjs";
import {catchError, map} from "rxjs/operators";
import { environment } from "../../../../environments/environment";
import {ConstantService} from "../../../core/services/constant.service";


@Injectable({
  providedIn: 'root'
})
export class UsersService {

    private userUrl= `${environment.apiUrl}/admin/realms/${environment.realm}`;
    private executiveProject = ConstantService.USERS_REALMS

    constructor(private http: HttpClient) { }

    getListUser(): Observable<any> {
        return this.http.get<{}>(`${this.userUrl}/users?first=0&max=1000`).pipe(
            map((data) => {
              return data;
            })
        );
    }

    getListExecutiveUser(): Observable<any> {
        return this.http.get<{}>(`${this.executiveProject}`).pipe(
            map((data) => {
                return data;
            })
        );
    }

    getListRole(): Observable<any> {
        return this.http.get<{}>(`${this.userUrl}/roles`).pipe(
            map((data) => {
                return data;
            }),
            catchError((error) => {
                return ('0'); // Reenvía el error para que lo manejen en el componente que llama a getListRole
            })
        );
    }
    getListRoleUser(userId: string): Observable<any> {
        return this.http.get<{}>(`${this.userUrl}/users/${userId}/role-mappings`).pipe(
            map((data) => {
                return data;
            })
        );
    }

    postUser(data: {}): Observable<any> {
        return this.http.post<any>( `${this.userUrl}/users`, data ).pipe(
            map((response) => {
              return response;
            })
        );
    }

    postKeycloakExecutiveUser(data: any): Observable<any> {
        return this.http.post<{}>(`${this.executiveProject}keycloak-user/`, data).pipe(
            map((response) => {
                return response;
            })
        );
    }

    patchKeycloakExecutiveUser(data: any): Observable<any> {
        return this.http.patch<{}>(`${this.executiveProject}keycloak-user/`, data).pipe(
            map((response) => {
                return response;
            })
        );
    }

    patchKeycloakExecutiveUserPassword(data: any): Observable<any> {
        return this.http.patch<{}>(`${this.executiveProject}keycloak-user/password/`, data).pipe(
            map((response) => {
                return response;
            })
        );
    }

    postRoles(data: {}): Observable<any> {
        return this.http.post<any>( `${this.userUrl}/roles`, data ).pipe(
            map((response) => {
              return response;
            })
        );
    }

    putUser(data: any): Observable<any> {
        const url = `${this.userUrl}/users/${data.id}`;

        return this.http.put<{}>(url, data).pipe(
            map((data) => {
              return data;
            })
        );
    }

    putRoles(data: any): Observable<any> {
        const url = `${this.userUrl}/roles/${data.id}`;

        return this.http.put<{}>(url, data).pipe(
            map((response) => {
                return response;
            })
        );
    }

    deleteRoles(data: any): Observable<any> {
        const url = `${this.userUrl}/roles/${data.id}`;

        return this.http.delete<{}>(url, data).pipe(
            map((response) => {
                return response;
            })
        );
    }

    deleteUser(ID:string): Observable<any> {
        const url = `${this.userUrl}/users/${ID}`;
        return this.http.delete<{}>(url).pipe(
            map((data) => {
              return data;
            })
        );
    }

    getRoleUser(userId: string): Observable<any> {
        return this.http.get<{}>(`${this.userUrl}/users/${userId}/role-mappings/realm`).pipe(
            map((data) => {
                return data;
            })
        );
    }

    postRoleUser(userID: any, item: any): Observable<any> {
        return this.http.post<{}>(`${this.userUrl}/users/${userID}/role-mappings/realm`, item).pipe(
            map((data) => {
                return data;
            })
        );
    }

    deleteRoleUser(userID: any, item: any): Observable<any> {
        return this.http.delete<{}>(`${this.userUrl}/users/${userID}/role-mappings/realm`, item).pipe(
            map((data) => {
                return data;
            })
        );
    }


    getUserToatBackEnd(uname): Observable<any> {
        return this.http.get<{}>(`${this.executiveProject}?user_keycloak=${uname}`).pipe(
            map((data) => {
                return data;
            })
        );
    }

    postUserToatBackEnd(data): Observable<any> {
        return this.http.post<{}>(`${this.executiveProject}`, data).pipe(
            map((data) => {
                return data;
            })
        );
    }

    patchUserToatBackEnd(data): Observable<any> {
        return this.http.patch<{}>(`${this.executiveProject}${data.id}`, data).pipe(
            map((data) => {
                return data;
            })
        );
    }

}
